/* Tags the new customer so the team can filter the email list and the SMS (phone-provided) list. */
(() => {
  const init = (form) => {
    if (form.dataset.abmSignupReady) return;
    form.dataset.abmSignupReady = 'true';
    form.addEventListener('submit', () => {
      const tags = form.querySelector('[data-abm-signup-tags]');
      const phone = form.querySelector('input[name="contact[phone]"]');
      if (!tags) return;
      const list = ['newsletter', 'website-signup'];
      if (phone && phone.value.replace(/\D/g, '').length >= 7) list.push('sms-opt-in');
      tags.value = list.join(', ');
    });
  };
  const boot = (scope) => scope.querySelectorAll('[data-abm-signup-form]').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
